import { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { UseAxios } from '../../../common/useAxios';
import defaultAxios from 'axios';
import { backendUrl } from '../../../common/constantVarialble';

interface PrmInfo {
    param_name?: string;
    param_seq?: string;
    param_value?: string;
}

function TestTab({ program_id, prmInfo, setPrmInfo, setTestResult }: { program_id: string, prmInfo: PrmInfo[], setPrmInfo: React.Dispatch<React.SetStateAction<any>>, setTestResult: React.Dispatch<React.SetStateAction<any>> }) {

    const executeTest = async () => {
        try {

            const params: Record<string, string> = {};

            prmInfo.forEach((param) => {
                params[param.param_name || ""] = param.param_value || "";
            })

            const { data } = await defaultAxios({
                method: 'post',
                //url: 'http://localhost:5000/api/request/',
                url: backendUrl,
                data: {
                    program_id: program_id,
                    params: params,
                    page_index: -1,
                },
            });

            //// Convert the data to a formatted JSON string with line breaks and indentation
            const resultString = JSON.stringify(data, null, 2);

            return resultString;

        } catch (error) {
            console.error(error);
            return null;
        }
    }




    const onMoveUpClick = (index: number) => {
        if (index === 0) return; // 첫 번째 항목이면 더 이상 위로 이동할 수 없음

        const updatedParameterList = [...prmInfo];
        // 현재 항목과 바로 위 항목을 서로 교환
        [updatedParameterList[index - 1], updatedParameterList[index]] = [
            updatedParameterList[index],
            updatedParameterList[index - 1],
        ];
        setPrmInfo(updatedParameterList);
    };

    const onMoveDownClick = (index: number) => {
        if (index === prmInfo.length - 1) return; // 마지막 항목이면 더 이상 아래로 이동할 수 없음

        const updatedParameterList = [...prmInfo];
        // 현재 항목과 바로 아래 항목을 서로 교환
        [updatedParameterList[index].param_name, updatedParameterList[index + 1].param_name] = [
            updatedParameterList[index + 1].param_name,
            updatedParameterList[index].param_name,
        ];
        setPrmInfo(updatedParameterList);
    };


    const onTestClick = async () => {
        console.log("test click");
        console.log(prmInfo);
        const resultString = await executeTest();
        if (resultString) {
            console.log("test Click Result");
            console.log(resultString);

            setTestResult("percent/test/result>\n" + resultString);
        }

    }

    return (
        <div className=" flex flex-col w-full bg-gray-900 text-body px-10 py-8 text-white overflow-auto " style={{ height: "80vh" }}>
            {prmInfo.length > 0 && (
                <table className="table-auto w-full mt-4">
                    <thead>
                        <tr>
                            <th className="px-4 py-2 border border-slate-700 text-body" style={{ width: "20%" }}>
                                {" "}
                            </th>
                            <th className="px-4 py-2 border border-slate-700" style={{ width: "40%" }}>
                                Parameter
                            </th>
                            <th className="px-4 py-2 border border-slate-700" style={{ width: "40%" }}>
                                Value
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {prmInfo.map((item, index) => (
                            <tr key={index}>
                                <td className="border py-2 border-slate-700 text-center" style={{ width: "20%" }}>
                                    <div className="flex flex-row justify-between ml-2">
                                        <div className="flex flex-col space-y-2">
                                            <FaChevronUp
                                                className="cursor-pointer  hover:text-cyan-400 transition-all duration-200"
                                                onClick={() => onMoveUpClick(index)}
                                            />
                                            <FaChevronDown
                                                className="cursor-pointer  hover:text-cyan-400 transition-all duration-200"
                                                onClick={() => onMoveDownClick(index)}
                                            />
                                        </div>

                                        <div className="text-body  w-full flex justify-center items-center mr-4">
                                            {index + 1} {/* Adjust the displayed index */}
                                        </div>
                                    </div>
                                </td>
                                <td className="border px-4 py-2 border-slate-700 items-center" style={{ width: "40%" }}>
                                    {item.param_name}
                                </td>
                                <td className="border px-2 py-3 border-slate-700" style={{ width: "40%" }}>
                                    <input
                                        className="appearance-none border-none block w-full rounded bg-slate-500 bg-opacity-50 p-2 leading-tight outline-none text-white focus:bg-opacity-100 transition-all duration-300"
                                        id={index + ""}
                                        type="text"
                                        value={item.param_value}
                                        onChange={(e) => {
                                            const updatedParameterList = prmInfo.map((p, i) =>
                                                i === index ? { param_seq: (i + 1).toString(), param_name: p.param_name, param_value: e.target.value } : p
                                            );
                                            setPrmInfo(updatedParameterList);
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            )}

            <div className="w-full mt-6">
                <button className="group relative h-10 w-full px-4 overflow-hidden rounded-2xl bg-blue-500 text-lg font-bold text-white" onClick={onTestClick}>
                    Test
                    <div className="absolute inset-0 h-full w-full scale-0 rounded-2xl transition-all duration-300 group-hover:scale-100 group-hover:bg-white/30"></div>
                </button>
            </div>
        </div>
    );
}

export { TestTab };